var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2_15135)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_2_15135)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2_15135",
    x: 0,
    y: 0,
    width: 20,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_15135"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_15135",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_15135",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_15135",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFoElEQVR4nO2da4gWVRjHj5XrigUrQpBd6CZdsPKCSlCafejywSIqKCnxy0oJ1QeJoC9ZH9IoDCFajaC0CwSmlUhJIEREF2o1K8GiD4UpteVKG7W17v7i8T3EW82ZmTNzZuacmfnBCy+8Z88857/znnme8zznvEq1tLS0tLS0tLR0AfQC64Ej+iXve7vbtOQEmAl8xP/5DDg7b/8t6oTIc4HvMPMDsKgVK9+dfAfwO8mMAitbsS0BTtZzsC0b5W9tr9dIgNOAN8nOO0Bf1ePwGuBC4AD5+Rq4pOrxeAlwPTCMO34FllU9Lq8AVgFjuOc48JBqOnSCkK0Uz9ak4AboAZ4ADke4j/Jg7lEBByEfUx4S8MyMsSfJy1mvahiEFIUxuIm4k//LERUSwJ0pg5CiiAxu0vyhqnkQUhSbgVO67EtEBRKEvIV//BPcpGmsfAaY5SgIKYpvJLhJ01D5CnAjcAz/SRUoKR8BHtABQ21QPgFMAV6ghqgAMiG1QPkAMA/4nhqjqsaDIKQUqhTYtyCkUKoSuU87/E2ir2yRfQ9CigxuLi1L5BscZ0JCQzI3Nxctcu2CkIxMAGuBSa4FluzDy1mtqjEvOc28AOuqHpHHPO5SaMlMtERzuBW6HA65FLoxQUkG1rl+GIrY7RRSRRkCDUNVBQ1DtUKXQyu0PePAPl1PLXV/1wDnA9P180iyRKfrNZ1rgfuB51qh04u7R4pngBkqJAiDUWBA7lgVKvi/8LMlrrAxGPCXg8BiVRfwk22128OCf1PFGgvbxbNYCjwG7NAZo6PAX8Cf+v1X+rNHtWcypVhFzcb6whiwIqXN88VVy1iqNqyrUOcVr+6/jfblTl6Rsu5kt8Prvg3MaZLQaxJsnKoDk+MFfZOeLnzzP9XzaoJ9FwH7S7BDosxZdRX6oBS4x9i2CPi5RHuGgIV1E3oizk/WIo/YdOhojCOFiE11bEmYLqzvZIdjHHI+jVANf5jCav3gyzQnOx7jPqcPSKphIMYe8S4yUcAYN4Qs9LhpFU77yVlcuA+A/pgx3gcMZnT9rghV6D0xttgGIzKP35JynJOAuzJEk7tCFXplTFhtgwh2WYbxzrf0ZsQ7mhua0OOmzIheu7Ahbqo4kcqK+fwey2ttCk3ovTGrcMcs3a/JEf0sAD7R/1B57QWui2g3WfeRlqO5az8ol40GG2Sp04Ydhjn4kCENdnFEe1nztmFJSEKvMtgg68k2PGv4Vsg6dBS7dUVS90sONrRhbUhCLzHY8IZlPy8a+lkN/FaQ7dtDEvpcgw0HXMz1ui+p67hdBz7v620ULvgyJKFnGGywXdeYSJshAU6SoAN4MOfmqKGQhO4x2CD5PVvEo5hmOVYRvT/jxtXRpgqNfqDNzrgrTdy/2go93WBDnsX9MX08593AORbjfq3OU8d5Bhtcbiz9USddZWvbVabtbcBtZT8MrbIYOVnqyL2zQVbtzoi45pyy3bsyDwjsN9ggxS02PB8RgMR9Kx6OuOblltd8JK/QUjdcFpsNNkgFUa7AB1ge0/6miPbLLK+Zrw5Qh66StimD/TE2DOe9u/R68+ddh9F+C9xraPuMxfV+cbKhCDirJLEngDMNNkiZVlrkFy9OTTiDpDfhOKMRF6k3a/RdJSmfDwt+QK6OSWPZsK37FEeLcU4D3rO8OcopGysLOm6ZDe+aXEZD/7OBTy2vsVPVDToul+1h3xJVvgLcGtPvcu1C2kaDY1nSZUFAp+AwEzF9ZuVJVfMT1gc9EFq8l6mqztDZGzhUodA/AReoJgAsrLDIcYFqEnSy2nJ3lYUEJleqJkJnGikjmBpszHSR8IDcUNDvvEifT7W/q9iFzv3t0tFaXqSPnbX1kx3+NMkmXUGUZR4eqF1YrQpE19gt1tmU7ZIF0WkxiRblJe+/AF7Xba7Oswr3N8Xa4VcK5mfWAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIntelligence);
export default __webpack_public_path__ + "static/media/location_intelligence.29b2e086e1fb9a44821c49e36bf56f03.svg";
export { ForwardRef as ReactComponent };